export class ConeConfiguracao {
    constructor(
        
        public file_to_upload = null,
        public logotipo = "",
        public cor_fundo = "",
        public cor_cabecalho = "",
        public cor_fonte_cabecalho = "",
        public cor_fonte_titulo = "",

        public cor_camada_1 = "",
        public cor_interna_1_camada_1 = "",
        public cor_interna_2_camada_1 = "",
        public cor_interna_3_camada_1 = "",
        public fundo_circulo_camada_1 = "",
        public cor_fonte_camada_1 = "",

        public cor_camada_2 = "",
        public cor_interna_1_camada_2 = "",
        public cor_interna_2_camada_2 = "",
        public cor_interna_3_camada_2 = "",
        public fundo_circulo_camada_2 = "",
        public cor_fonte_camada_2 = "",

        public cor_camada_3 = "",
        public cor_interna_1_camada_3 = "",
        public cor_interna_2_camada_3 = "",
        public cor_interna_3_camada_3 = "",
        public fundo_circulo_camada_3 = "",
        public cor_fonte_camada_3 = "",

        public cor_camada_4 = "",
        public cor_interna_1_camada_4 = "",
        public cor_interna_2_camada_4 = "",
        public cor_interna_3_camada_4 = "",
        public fundo_circulo_camada_4 = "",
        public cor_fonte_camada_4 = "",

        public cor_camada_5 = "",
        public cor_interna_1_camada_5 = "",
        public cor_interna_2_camada_5 = "",
        public cor_interna_3_camada_5 = "",
        public fundo_circulo_camada_5 = "",
        public cor_fonte_camada_5 = "",

        public cor_camada_6 = "",
        public cor_interna_1_camada_6 = "",
        public cor_interna_2_camada_6 = "",
        public cor_interna_3_camada_6 = "",
        public cor_fonte_camada_6 = "",

        public cor_camada_7 = "",
        public cor_interna_1_camada_7 = "",
        public cor_interna_2_camada_7 = "",
        public cor_interna_3_camada_7 = "",
        public cor_fonte_camada_7 = "",

        public cor_padrao_grafico_direita = "",
        public cor_sucesso_grafico_direita = "",
        public cor_tratativa_grafico_direita = "",
        public cor_sem_nc = "",
        public cor_valor_acumulado = "",
        public cor_valor_acumulado_em_risco = "",
        public cor_eventos_grafico_direita = "",
        public cor_fonte_grafico_direita = "",

        private created_at = new Date(),
        private updated_at = new Date(),
    ) {
    }
}